var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading flex flex-col items-center justify-center py-4"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"red"}}),_c('v-card-text',{staticClass:"text-center"},[_vm._v("Loading...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }